function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotAvailableIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 109 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43.818,41.175l-2.264,-0l-10.981,-16.007l-1.365,-2.109l-0.062,0.031l0.031,2.513l-0,15.572l-2.854,-0l-0,-23.265l2.885,-0l11.787,17.588l0.062,-0.031l-0.062,-2.482l0,-15.075l2.823,-0l0,23.265Zm13.984,-24.63l2.544,-0l-10.702,28.538l-2.482,0l10.64,-28.538Zm20.641,24.63l-1.861,-5.553l-10.237,0l-1.861,5.553l-3.412,-0l8.562,-23.265l3.784,-0l8.592,23.265l-3.567,-0Zm-6.948,-20.939l-0.776,2.42l-3.443,10.205l8.406,0l-3.381,-10.205l-0.713,-2.42l-0.093,0Z",
    style: {
      fillRule: "nonzero"
    },
    fill: "currentColor"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotAvailableIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Not_Available_Icon.f1f4374336c1af3c57dfd14f8b4714c7.svg";